// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2PQMN","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1C0Pt","obliqueLine":"membershipbadge_obliqueLine__2HItw"};